module.exports = __webpack_public_path__ + "img/lozko.e6b41d9a.jpg";